import axiosApiInstance from "../../../../api/axiosApiClient";
import { ExtractCurlParameters } from "../../promptManagement/shared/curlConverter";
import { InternalAPIError } from "../../../../utils/apiErrors";
import { handleApiError } from "../../../../utils/globalErrorHandler";

const BASE_MKSPROMPTMANAGEMENT_API_URL = process.env.REACT_APP_MKS_API_URL;

export const getDefaultChatbotConfig = async () => {
  try {
    const response = await axiosApiInstance.get(
      `${BASE_MKSPROMPTMANAGEMENT_API_URL}common/GetDefaultChatbotConfig`
    );

    if (response.status === 200) {
      let params = {
        url: response.data.url,
        method: response.data.method,
        headers: response.data.headers,
        body: response.data.body,
        userMessage: response.data.UserMessageFormat,
        lastMessageCount: response.data.LastMessagesCount,
        assistantMessage: response.data.AssistantMessageFormat,
        ChatGPTVersion: response.data.ChatGPTVersion,
        ShowCitation: response.data.ShowCitation,
        IsActive: response.data.IsActive,
      };
      let output = ExtractCurlParameters(response.data.CurlRequestString);
      params.url = output.url;
      params.method = output.method;
      params.body = output.body;
      params.headers = output.headers;
      params.headersV2 = response.data.UserMessageFormat;

      return params;
    }
  } catch (error) {
    handleApiError(new InternalAPIError());
  }
};

export const getMKSChatURLInfo = () => {
  getDefaultChatbotConfig();
};

export const checkSkillsAvailability = async () => {
  try {
    const response = await axiosApiInstance.get(
      `${BASE_MKSPROMPTMANAGEMENT_API_URL}skillstore/CheckSkillsAvailability`
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    handleApiError(new InternalAPIError());
  }
};
